<template>
    <main class="opacity-introjs">

        <section class="menu-mobile" v-if="detectaMobile" v-canaccess="'/acessorapidomobile'">
            <div class="content-960">
                <ul class="breadcrumb"></ul>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="text-center">
                        <h2 class="uppercase"><b> Acesso Rápido </b> </h2>
                        <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
                    </div>
                    <div class="no-img">
                        <ul class="breadcrumb" v-canaccess="'/iniciarprocessoseletivo'">
                            <li><router-link to="/iniciarprocessoseletivo">Iniciar Processo Seletivo</router-link></li>
                        </ul>

                        <ul class="breadcrumb" v-canaccess="'/colaborador'">
                            <li><router-link to="/colaborador">Colaboradores / Candidatos</router-link></li>
                        </ul>

                        <ul class="breadcrumb" v-canaccess="'/candidato'">
                            <li><router-link to="/candidato">Testes / Entrevistas</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <section v-canaccess="'/revisarcolaboradores'">

            <div class="content-960">
                <ul class="breadcrumb"></ul>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Revise as situações dos colaboradores</b></h2>
                    </div>

                    <colaborador-desligamento v-if="escolaLogadaId > 0" :escola-id="escolaLogadaId" />

                </div>
            </div>
        </section>
        
    </main>
    
</template>
<script>

    import colaboradorDesligamento from '../colaboradordesligamento'
    
    import auth from '@/common/auth'
    import TutorStep from '@/common/tutor-step'    

    export default {
        name: 'home',
        components: { colaboradorDesligamento },
        data() {
            return {
                escolaLogadaId: 0,
                detectaMobile: false,
                dialogDetalheMelhoria: false,                
                result: {},
                textoDetalheAtualizacao: "",
                changeLogId:0
            }
        },
        methods: {
            mobile() {
                if (navigator.userAgent.match(/Android/i)
                    || navigator.userAgent.match(/webOS/i)
                    || navigator.userAgent.match(/iPhone/i)
                    || navigator.userAgent.match(/iPad/i)
                    || navigator.userAgent.match(/iPod/i)
                    || navigator.userAgent.match(/BlackBerry/i)
                    || navigator.userAgent.match(/Windows Phone/i)
                ) {
                    this.detectaMobile = true;
                }
                else {
                    this.detectaMobile = false;
                }
            },           
            
        },
        mounted() {
            this.mobile();
            var user = auth.currentUser();

            this.usuarioLogado = auth.currentUser().sub;

            //console.log('usuario', user);

            if (user) this.escolaLogadaId = +user.tenant;
            TutorStep.start("/home");

            //console.log('escolaId',this.escolaLogadaId)

            },
        
    };
</script>
